import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 16 14"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "currentColor",
      "fill-rule": "evenodd",
      d: "M10.362.135a7.004 7.004 0 0 0-8.33 6.123L.907 5.133a.531.531 0 0 0-.751.75L2.12 7.85a.53.53 0 0 0 .804 0L4.89 5.884a.531.531 0 1 0-.751-.751L3.115 6.157a5.942 5.942 0 1 1 5.88 6.79.531.531 0 1 0 0 1.061A7.004 7.004 0 0 0 10.363.135",
      "clip-rule": "evenodd"
    }, null, -1)
  ])))
}
export default { render: render }